<template>
  <div>
    <div
    v-if="
      $route.path.indexOf('_detail') === -1 &&$route.path.indexOf('_edit') === -1
    "
  >
    <el-row :gutter="24">
      <el-col :span="3">
        <el-input
          placeholder="商家编号"
          v-model="params.merchant_id"
          style="width: 100%"
          size="mini"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-input
          placeholder="企业对公账户"
          v-model="params.account_no"
          style="width: 100%"
          size="mini"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-input
          placeholder="开户银行名称"
          v-model="params.parent_bank_name"
          style="width: 100%"
          size="mini"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-input
          placeholder="开户行支行名称"
          v-model="params.bank_name"
          style="width: 100%"
          size="mini"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-input
          placeholder="支付行号，12位数字"
          v-model="params.union_bank"
          style="width: 100%"
          size="mini"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-cascader
          clearable
          v-model="params.regions_id"
          size="mini"
          :options="regions"
          @change="handleRegionChange"
          style="width: 200px"
        ></el-cascader>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="3">
        <el-select v-model="params.disabled" placeholder="是否禁用" size="mini">
          <el-option label="否" value="0"></el-option>
          <el-option label="是" value="1"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="searchData" size="mini"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="toAdd()" size="mini">新增+</el-button>
      </el-col>
    </el-row>
    <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
      <el-table-column prop="id" label="ID"></el-table-column>
   
      <el-table-column
        prop="merchant_id"
        label="账户主体"
      ></el-table-column>
      <el-table-column prop="account_no" label="企业对公账户"></el-table-column>
      <el-table-column
        prop="parent_bank_name"
        label="开户银行名称"
      ></el-table-column>
      <el-table-column
        prop="bank_name"
        label="开户行支行名称"
      ></el-table-column>
      <el-table-column prop="union_bank" label="支付行号"></el-table-column>
      <el-table-column prop="province" label="开户行所在省"></el-table-column>
      <el-table-column prop="city" label="开户行所在市"></el-table-column>
         <el-table-column label="是否禁用">
        <template slot-scope="scope">
          <el-tag
            size="mini"
            effect="plain"
            type="success"
            v-if="scope.row.disabled == '0'"
            >否</el-tag
          >
          <el-tag size="mini" effect="plain" v-else>是</el-tag>
        </template>
      </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              effect="plain"
              @click="edit(scope.row.id)"
              >编辑</el-tag
            >
            <el-tag
              size="mini"
              effect="plain"
              @click="del(scope.row.id,scope.$index)"
              >删除</el-tag
            >
          </template>
        </el-table-column>
    </el-table>
    <div class="content-center content-top-padded">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50]"
        :total="total_count"
        :page-size="params.pagesize"
      >
      </el-pagination>
    </div>
  </div>
   <router-view></router-view>
  </div>
</template><script>
import { mapGetters } from "vuex";
import {
  getMerchantCompanyAccount,
  delMerchantCompanyAccount,
} from "../../../api/merchant";
import district from "../../../common/district.json";
// 取选中地区的值
function getCascaderObj(val, opt) {
  return val.map(function (value, index, array) {
    for (var itm of opt) {
      if (itm.value === value) {
        opt = itm.children;
        return itm;
      }
    }
    return null;
  });
}

export default {
  components: {},
  data() {
    return {
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
      },
      regions: district,
      dataList: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    handleRegionChange: function (value) {
      var vals = getCascaderObj(value, this.regions);
      if (vals) {
        this.params.province = vals[0].label;
        this.params.city = vals[1].label;
        this.params.area = vals[2].label;
        console.log(vals, this.params.regions_id);
      }
    },
    toAdd() {
      this.$router.push({ path: this.matchHidePage("edit") });
    },
    edit(id) {
      this.$router.push({
        path: this.matchHidePage("edit"),
        query: { id: id },
      });
    },
     del(id, index) {
      var that = this;
      this.$confirm("确定要删除该商品？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delMerchantCompanyAccount(id).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已删除",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    getDataList() {
      this.loading = true;
      getMerchantCompanyAccount(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
    //导出预留
    exportData() {
      this.$message({
        type: "success",
        message: "待开发!",
      });
    },
  },
  mounted() {
    this.getDataList();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?01980e58